export const LIVE_SUBURB_SLUG = "oakleigh";

export const suburbs = [
  {
    name: "Oakleigh",
    slug: "oakleigh",
    live: true,
    nearby: ["Oakleigh South", "Clayton", "Chadstone", "Huntingdale"],
  },
  {
    name: "Chadstone",
    slug: "chadstone",
    nearby: ["Oakleigh", "Malvern East", "Mount Waverley", "Huntingdale"],
  },
  {
    name: "Clayton",
    slug: "clayton",
    nearby: ["Clayton South", "Clayton North", "Oakleigh", "Huntingdale"],
  },
  {
    name: "Clayton South",
    slug: "clayton-south",
    nearby: ["Clayton", "Clayton North", "Springvale", "Noble Park"],
  },
  {
    name: "Clayton North",
    slug: "clayton-north",
    nearby: ["Clayton", "Clayton South", "Oakleigh", "Huntingdale"],
  },
  {
    name: "Moorabbin",
    slug: "moorabbin",
    nearby: ["Bentleigh", "Moorabbin Airport", "Highett", "Cheltenham"],
  },
  {
    name: "Murrumbeena",
    slug: "murrumbeena",
    nearby: ["Carnegie", "Bentleigh", "Malvern East", "Oakleigh"],
  },
  {
    name: "Burwood",
    slug: "burwood",
    nearby: ["Burwood East", "Glen Waverley", "Mount Waverley", "Malvern"],
  },
  {
    name: "Huntingdale",
    slug: "huntingdale",
    nearby: ["Oakleigh", "Clayton", "Murrumbeena", "Springvale"],
  },
  {
    name: "Glen Waverley",
    slug: "glen-waverley",
    nearby: ["Mount Waverley", "Burwood", "Wheelers Hill", "Mulgrave"],
  },
  {
    name: "Mt Waverley",
    slug: "mt-waverley",
    nearby: ["Glen Waverley", "Chadstone", "Burwood", "Mount Waverley East"],
  },
  {
    name: "Springvale",
    slug: "springvale",
    nearby: ["Noble Park", "Clayton South", "Dandenong", "Huntingdale"],
  },
  {
    name: "Bentleigh",
    slug: "bentleigh",
    nearby: ["Bentleigh East", "Moorabbin", "Murrumbeena", "McKinnon"],
  },
  {
    name: "Malvern",
    slug: "malvern",
    nearby: ["Malvern East", "Armadale", "Toorak", "Burwood"],
  },
  {
    name: "St Kilda",
    slug: "st-kilda",
    nearby: ["St Kilda East", "Elwood", "Balaclava", "Melbourne CBD"],
  },
  {
    name: "Melbourne",
    slug: "melbourne",
    nearby: ["South Melbourne", "Richmond", "Carlton", "St Kilda"],
  },
  {
    name: "Noble Park",
    slug: "noble-park",
    nearby: ["Springvale", "Dandenong", "Clayton South", "Keysborough"],
  },
];

export const fleetTypes = [
  { label: "Compact Cars", icon: "🚗" },
  { label: "Sedans", icon: "🚙" },
  { label: "SUVs", icon: "🚘" },
  { label: "VANS", icon: "🚐" },
  { label: "7-Seaters", icon: "👨‍👩‍👧‍👦" },
];

export const whyChoosePoints = [
  "Affordable daily and weekly rental rates",
  "Flexible pickup and drop-off options",
  "Clean, reliable and regularly maintained vehicles",
  "Friendly family-owned local business",
  "Convenient Huntingdale location just minutes from Oakleigh",
];

export const getSuburbBySlug = (slug) =>
  suburbs.find((suburb) => suburb.slug === slug);

export const isSuburbLive = (slug) => {
  const suburb = getSuburbBySlug(slug);
  return suburb?.live === true;
};

export const getLiveSuburbs = () =>
  suburbs.filter((suburb) => isSuburbLive(suburb.slug));

export const getComingSoonSuburbs = () =>
  suburbs.filter((suburb) => !isSuburbLive(suburb.slug));

export const getSuburbPath = (slug) => `/car-rental-${slug}`;

export const getSuburbSEO = (suburb) => ({
  title: `Car Rental ${suburb.name} | EZ Car Rentals Melbourne`,
  description: `Need affordable car rental in ${suburb.name}? EZ Car Rentals offers reliable short and long-term car hire near ${suburb.name} with flexible pickup from nearby Huntingdale. Book online today.`,
  keywords: `car rental ${suburb.name}, car hire ${suburb.name}, ${suburb.name} car rental, cheap car hire ${suburb.name}, van hire ${suburb.name}, ute rental ${suburb.name}, EZ Car Rentals`,
  url: `https://ezcarrentals.com.au/car-rental-${suburb.slug}`,
});

export const getComingSoonSEO = (suburb) => ({
  title: `Car Rental ${suburb.name} Coming Soon | EZ Car Rentals`,
  description: `Car rental in ${suburb.name} is coming soon. EZ Car Rentals currently serves Oakleigh and nearby suburbs from our Huntingdale depot. Request a quote today.`,
  keywords: `car rental ${suburb.name}, ${suburb.name} car hire coming soon, EZ Car Rentals`,
  url: `https://ezcarrentals.com.au/car-rental-${suburb.slug}`,
});

export const getNearbyText = (suburb) =>
  suburb.nearby.slice(0, 4).join(", ");
